export enum InventHoldStatusType {
    BillHold = 'BillHold',
    HoldStock = 'HoldStock',
    Invalid = 'Invalid'
}
